// Query key factories moved from domains/user to break circular dependency
// These provide the query key structure without queryFn to keep constants dependency-free
/**
 * Login link query key factory
 * Returns a query key structure for fetching login links
 */ export const getLoginLinkQueryKey = {
    login: (state)=>({
            queryKey: [
                'user',
                'login',
                state
            ]
        })
};
/**
 * Logout link query key factory
 * Returns a query key structure for fetching logout links
 */ export const getLogoutLinkQueryKey = {
    logout: ()=>({
            queryKey: [
                'user',
                'logout'
            ]
        })
};
